import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ImportReport } from '@/types/api';

export interface OdsImportInput {
  file: File;
  dryRun: boolean;
  strict?: boolean;
}

/**
 * Mutation für den ods-Bulk-Import.
 *
 * Nutzt FormData (multipart/form-data) - das Backend erwartet `file`,
 * `dry_run` und `strict` als Form-Felder (siehe openapi.yaml).
 */
export function useOdsImport(): ReturnType<
  typeof useMutation<ImportReport, Error, OdsImportInput>
> {
  return useMutation<ImportReport, Error, OdsImportInput>({
    mutationFn: ({ file, dryRun, strict }) => {
      const form = new FormData();
      form.append('file', file);
      form.append('dry_run', String(dryRun));
      if (strict !== undefined) form.append('strict', String(strict));
      return api.postForm<ImportReport>('/import/ods', form);
    },
  });
}
